module.exports = {
  "title": "search",
  "sub_text": "221B Baker Street",
  "placeholder": "Type here to search",
  "in_hub": "in:hub",
  "in": "in",
  "seek_enabled": {
    "sub_text": "Powered by",
    "placeholders": {
      "seek": "Search by Seek",
      "global": "Search by Global"
    }
  },
  "filters": {
    "title": "Filter by",
    "everything": "Everything"
  },
  "actions": {
    "view_in_seek": "View in Seek",
    "view_more": "View More",
    "try_asking_seek": "Try asking seek",
    "go_to_seek": "Go to Seek"
  },
  "loading": {
    "seek_response": "Scanning through your content hub",
    "searching": "Searching"
  },
  "asset": {
    "all_tags": "All Tags",
    "asset_detail_view": {
      "tags": "Tags",
      "available_in": "Available in",
      "loading": {
        "details": "Loading details"
      },
      "actions": {
        "view": "View",
        "share": "Share",
        "show_details": "Show Details",
        "hide_details": "Hide Details",
        "add_to_my_collection": "Add to my collection"
      }
    }
  },
  "empty_message": {
    "title": "What's on your mind?",
    "sub_text": "It's my business to know what other people don't know",
    "no_results": {
      "title": "No results found",
      "sub_text": "Would you like to notify administrators to add new content for your query?",
      "description": "Holmes, Watson, Lestrade & Moriarty - Not the names you were looking for I guess!",
      "actions": {
        "notify": "Click here to notify",
        "notifying": "Notifying administrators"
      },
      "toast": {
        "notify_success": "Content administrators notified successfully"
      }
    }
  },
  "sliders": {
    "custom_fields": {
      "title": "Categories",
      "actions": {
        "clear_all": "Clear All",
        "view_more": "View More"
      }
    }
  }
}